import { PropsWithChildren, useCallback } from 'react';
import { Toaster as SonnerToaster, toast } from 'sonner';
import {
  NotificationContextValue,
  NotificationContext,
} from './NotificationContext';
import { createToast } from './Notification.utils';

type NotificationProviderProps = PropsWithChildren<{
  isExtension?: boolean;
}>;

export const NotificationProvider = ({
  children,
  isExtension,
}: NotificationProviderProps) => {
  const open: NotificationContextValue['open'] = useCallback(
    params => {
      if (!params) return;

      const { key, message, type, description, duration, action } = params;

      const opts = {
        description,
        id: key,
        isExtension,
        duration,
        action,
      };
      if (
        !['success', 'error', 'warning', 'info', 'alert', 'loading'].includes(
          type
        )
      )
        return;

      createToast(type)(message, opts);
    },
    [isExtension]
  );

  const close: NotificationContextValue['close'] = useCallback(
    key => toast.dismiss(key),
    []
  );

  return (
    <NotificationContext.Provider value={{ open, close, isExtension }}>
      <SonnerToaster
        position="top-right"
        offset={{ top: '70px', right: '20px' }}
      />
      {children}
    </NotificationContext.Provider>
  );
};
